import React, { useEffect, useState } from "react"
import Img1 from "../../assets/images/CaseStudy.avif"
import ConfigUrl from "../../config"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import secureLocalStorage from "react-secure-storage"

export const locationOptions = [
  { label: "India", value: "1" },
  { label: "UK", value: "2" },
]

const CaseStudy = () => {
  const caseStudy = secureLocalStorage.getItem("allCaseStudy")
  const { type } = useParams()
  const Navigate = useNavigate();
  const path = useLocation()

  const [filteredCaseStudies, setFilteredCaseStudies] = useState([])

  useEffect(() => {
    if (caseStudy && Array.isArray(caseStudy)) {
      const filtered = caseStudy.filter(c => c.services === type)
      setFilteredCaseStudies(filtered)
    }
  }, [caseStudy, type])

  function stripHtmlTags(html) {
    if (!html) return ""
    return html.replace(/<[^>]*>?/gm, "")
  }

  return (
    <div className="p-4">
      <h3 className="text-center color-purple fw-bold mb-3">
        Explore Our Projects in {type}
      </h3>
      <h5 className="text-center mb-4">How We Help Your Business Succeed</h5>
      <div className="row my-3 justify-content-start pe-0">
        {filteredCaseStudies.map(cs => {
          let projectImages = []

          try {
            if (cs.project_image) {
              projectImages = JSON.parse(cs.project_image).map(img =>
                img.replace(/\\/g, "/")
              )
            }
          } catch (err) {
            console.error("Error parsing project_image:", err)
          }
          return (
            <div className="col-xl-4 mb-3 mb-xl-0" key={cs.id}>
              <div
                className="case-study-card"
                onClick={() => Navigate(`${ConfigUrl.appurl}casestudydetail/${cs.id}${path?.search}`)}
              >
                <img src={projectImages ? `${ConfigUrl.imageurl}/${projectImages[0]}` : Img1} className="w-100 object-fit-cover"></img>
                <h5 className="color-purple fw-bolder p-3 pb-0">
                  {cs.project_name}
                </h5>
                <div className="d-flex justify-content-between p-2 pt-0 pb-0">
                  <div className="fw-bolder text-dark px-2 pb-0">
                    <h6 className="fst-italic fw-medium">
                      {cs?.technologies?.map((obj, i, arr) => (
                        <span className="" key={i}>
                          {obj}{i < arr.length - 1 ? ', ' : ''}
                        </span>
                      ))}
                    </h6>
                  </div>
                </div>
                <h6 className="lh-base case-desc p-2 px-3" dangerouslySetInnerHTML={{ __html: cs.project_overview?.slice(0, 150) + ' ...' }} />
                <div className="p-2 pt-0 px-3 mb-3">
                <button className=" btn btn-save">View Project <i className="fas fa-long-arrow-alt-right ps-2"></i></button>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CaseStudy
